export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Drawing/GPdrawingOpen.png?d130e3f29a280c94ba259cbf559547c2";